import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import ServicesList from './components/ServicesList';
import ProcessSection from './components/ProcessSection';
import PricingSection from './components/PricingSection';

const Services = () => {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Navbar />
      <ServicesHero />
      <ServicesList />
      <ProcessSection />
      <PricingSection />
      <Footer />
    </div>
  );
};

export default Services;